/**
 * @description: 积分兑换汇总报表
 * @author: lyr
*/
<template>
    <div class="or-jfdhh-report">
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="兑换类型">
                    <el-select v-model="list_form.type" filterable clearable placeholder="请选择兑换类型" @change="changeType($event)">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="商品" value="1"></el-option>
                        <el-option label="卡券" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分类名称">
                    <el-select v-model="list_form.goods_type" filterable clearable placeholder="请选择分类名称" :disabled="list_form.type==''" v-if="list_form.type!='1'">
                        <el-option v-for="item in card_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="goods_type_str" readonly @click.native="openGoodsTypePop" v-if="list_form.type=='1'"></el-input>
                </el-form-item>
                <el-form-item label="兑换详情">
                    <el-input placeholder="请输入兑换详情名称" clearable v-model="list_form.goods_name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-row class="total-txt">
                <div class="item">使用积分合计：{{use_point}}</div>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="type_name" label="兑换类型"></el-table-column>
                <el-table-column prop="goods_type_name" label="分类名称"></el-table-column>
                <el-table-column prop="goods_name" label="兑换详情"></el-table-column>
                <el-table-column prop="quantity" label="兑换数量"></el-table-column>
                <el-table-column prop="use_point" label="使用积分"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 商品类型选择 -->
        <div class="goods-type-pop" ref="goods_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllGoodsTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.goods_type" @change="handleCheckGoodsTypeChange">
                    <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'or-jfdhh-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                card_type_list: [], // 卡券类型
                goods_type_list: [], // 商品/套餐类型
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    type: '',//兑换类型 1 商品 2卡券
                    goods_type: '',
                    goods_name: "",//兑换详情
				},
                // goods_type_str: '全部',
				list_table: [],
				list_page: 1,
                list_total: 0,
                use_point: 0,
                checkAllGoodsType: false,
            }
        },
        computed: {
            goods_type_str() {
                if (this.list_form.goods_type.length == 0) {
                    return ''
                }else if(this.list_form.goods_type.length == this.goods_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.goods_type.forEach(v => {
                        this.goods_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getCardTypeList()
                this.getGoodsTypeList()
                this.setShopDefaultTime(this.shop_list[0].id)
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取卡券类型
            getCardTypeList: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_merchantGiftType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.card_type_list = res.data.response.data;
                        _this.card_type_list.unshift({
                            id: '',
                            name: '全部'
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取商品/套餐类型
            getGoodsTypeList: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getAllGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "show_room_pack": -1
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('FinanceReport2/getPointsGoodsCountList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
							"type": _this.list_form.type,//兑换类型 1 商品 2卡券
                            "goods_type":_this.list_form.goods_type,
                            "goods_name": _this.list_form.goods_name,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.data.total)
                            _this.use_point = res.data.response.result.data.use_point
						}
						_this.list_table = res.data.response.result.data.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                if (!!val) {
                    this.setShopDefaultTime(val)
                }
            },

            changeType(val) {
                if (val == '1') { // 商品
                    this.list_form.goods_type = []
                }
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

            // 打开商品类型选择弹窗
            openGoodsTypePop() {
                let _this = this
                let c_goods_type = _this.list_form.goods_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                        _this.list_form.goods_type = c_goods_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.goods_type = c_goods_type
                    layer.closeAll()
                });
            },

            // 商品类型全选
            handleCheckAllGoodsTypeChange(val) {
                this.list_form.goods_type = []
                this.checkAllGoodsType = val
                if (val) {
                    this.goods_type_list.forEach(item => {
                        this.list_form.goods_type.push(item.id)
                    })
                }
            },

            // 选择商品类型
            handleCheckGoodsTypeChange(val) {
                this.checkAllGoodsType = val.length === this.goods_type_list.length
            },

            
            listExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport2/exporttPointsGoodsCountList" +
                    "?start_date=" + this.list_form.start_time +
                    "&end_date=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&type=" + this.list_form.type + //兑换类型 1 商品 2卡券
                    "&goods_type=" + this.list_form.goods_type +
                    "&goods_name=" + this.list_form.goods_name;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .total-txt {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .item {
            margin-right: 40px;
        }
    }
    .goods-type-pop {
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
</style>